import { useState, useEffect } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  InputAdornment,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Box,
} from "@mui/material";
import axiosInstance from "../../axiosInstance";

export default function EditEmployerDialog({
  open,
  onClose,
  employer,
  onUpdate,
}) {
  const [fullName, setFullName] = useState("");
  const [employerName, setEmployerName] = useState("");
  const [prefix, setPrefix] = useState("");
  const [role, setRole] = useState(null);
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (employer) {
      setFullName(employer.fullName);
      setMobile(employer.mobile);
      setEmployerName(employer.employerName)
      setPrefix(employer.prefix)
    }
  }, [employer]);

  const closePopup = () => {
    setFullName(employer.fullName);
    setMobile(employer.mobile);
    setEmployerName(employer.employerName)
    setPrefix(employer.prefix)
    onClose();
  };

  const handleSubmit = async () => {
    if (!fullName || !employerName || !mobile || !prefix) {
      setError("Name, mobile and role are required");
      return;
    }

    setSaving(true);

    try {
      const res = await axiosInstance.put(`/employers/${employer.userId}`, {
        fullName,
        mobile,
        employerName,
        prefix
      });

      onUpdate();
      closePopup();
    } catch (err) {
      setError("Failed to update employer");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Employer</DialogTitle>

      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Box display="grid" gap={2}>
          <TextField
            required
            label="Business Name"
            fullWidth
            margin="normal"
            value={employerName}
            onChange={(e) => setEmployerName(e.target.value)}
          />

          <TextField
            required
            label="Full Name"
            fullWidth
            margin="normal"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />

          <TextField
            label="Mobile Number"
            name="mobile"
            fullWidth
            required
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">🇮🇳 +91</InputAdornment>
              ),
              inputMode: "numeric",
            }}
            inputProps={{
              minLength: 10,
              maxLength: 10,
              pattern: "[0-9]{10}",
            }}
          />

          <TextField
            required
            label="Prefix"
            fullWidth
            margin="normal"
            value={prefix}
            onChange={(e) => setPrefix(e.target.value)}
          />

        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
